import { configureStore } from "@reduxjs/toolkit"

import accountinfoReducer from "./reducers/accountinfo"
import { errorsReducer, notificationsReducer, rateLimitReducer } from "./reducers/errors"
import loaderReducer from "./reducers/loader"
import localStorageReducer from "./reducers/localStorage"

export default configureStore({
  reducer: {
    accountinfo: accountinfoReducer,
    errors: errorsReducer,
    loader: loaderReducer,
    localStorage: localStorageReducer,
    notifications: notificationsReducer,
    rateLimit: rateLimitReducer
  }
})